export class BackendLimitsConstants {
  public static readonly INT32_MAX = 2147483647;
  public static readonly INT64_MAX = 9223372036854775807;
}
